// 動画の最適化で画面に出すエラー
export const OPTIMIZE_ERROR_MESSAGES = {
    no_video: '映像が入っていない動画です。',
    hdr: 'HDR の動画は最適化できません。SDR で書き出し直してください。',
    encoder_unavailable: '動画の最適化に使うファイルを読み込めませんでした。通信状況を確認して、添付し直してください。',
    failed: '最適化に失敗しました。',
};

export class OptimizeError extends Error {
    constructor(code, detail) {
        super(OPTIMIZE_ERROR_MESSAGES[code] || OPTIMIZE_ERROR_MESSAGES.failed);
        this.code = code;
        this.detail = detail;
    }
}
